import { UserCommunication } from '@this+that/models';

import { ShortcutContext } from './types';
import { useEmailListNavigation } from './useEmailListNavigation';

interface UseSentNavigationProps {
  filteredCommunications: UserCommunication[];
}

export function useSentNavigation({
  filteredCommunications,
}: UseSentNavigationProps) {
  return useEmailListNavigation({
    filteredCommunications,
    context: ShortcutContext.SENT,
  });
}
